import {combineReducers} from 'redux'
import {boloReducer} from './boloReducers';




export default combineReducers({
    reducer:boloReducer,
})
